function normalizeName(name: string): string {
  return name.trim().toLowerCase();
}

/**
 * Keep this in sync with the server-side `UniqueNameAllocator`.
 */
export class UniqueNameAllocator {
  private readonly takenNames: Set<string>;

  constructor(takenNames: Iterable<string>) {
    this.takenNames = new Set(Array.from(takenNames, normalizeName));
  }

  allocate(requestedName: string): string {
    const baseName = requestedName.trim();

    let name = baseName;
    for (let suffix = 1; this.takenNames.has(normalizeName(name)); suffix += 1) {
      name = `${baseName}-${suffix}`;
    }

    this.takenNames.add(normalizeName(name));
    return name;
  }
}
